import React from 'react';

const Icon16Orientation2ReclinerLeft = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <rect
      x="291.63"
      y="283.66"
      width="216.75"
      height="216.75"
      transform="translate(800 784.08) rotate(-180)"
      fill="transparent"
    />
    <path
      d="M89.33,231.42h187.85c7.98,0,14.45,6.47,14.45,14.45v369.66H74.88V245.87c0-7.98,6.47-14.45,14.45-14.45Z"
      transform="translate(366.5 846.94) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M42.2,231.42h23.49c5.07,0,9.18,4.11,9.18,9.18v250.64c0,5.07-4.11,9.18-9.18,9.18h-32.67V240.6c0-5.07,4.11-9.18,9.18-9.18Z"
      transform="translate(107.9 731.83) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="291.63"
      y="231.42"
      width="216.75"
      height="52.25"
      transform="translate(800 515.08) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <rect
      x="508.37"
      y="283.66"
      width="216.75"
      height="216.75"
      transform="translate(1233.5 784.08) rotate(-180)"
      fill="transparent"
    />
    <path
      d="M734.3,231.42h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
      transform="translate(1492.1 731.83) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="508.37"
      y="231.42"
      width="216.75"
      height="52.25"
      transform="translate(1233.5 515.08) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <rect
      x="74.88"
      y="231.42"
      width="216.75"
      height="52.25"
      transform="translate(366.5 515.08) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M300.63,500.41h198.75c4.97,0,9,4.03,9,9v43.25h-216.75v-43.25c0-4.97,4.03-9,9-9Z"
      transform="translate(800 1053.07) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <path
      d="M508.37,500.41h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <line
      x1="508.37"
      y1="283.66"
      x2="508.37"
      y2="500.41"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon16Orientation2ReclinerLeft;
